import { getStaticImageUrl } from "../config/gcs";
export const component = [
  {
    shape: getStaticImageUrl("contact/shape.png"),
  },
];

export const cookie = [
  {
    img: getStaticImageUrl("cookie/Cookie.png"),
    alt: "Cookies",
  },
];
